<template>
    <article
        class="article container px-4 mx-auto"
        :class="containerClass"
        v-if="doc"
    >
        <div
            v-if="doc.heading && doc.heading.text"
            class="mb-3w text-center"
            :class="inverse"
        >
            <div
                v-if="doc.subheading"
                class="text-strong uppercase ms-1 tracking-widest"
            >
                {{ doc.subheading }}
            </div>
            <heading
                v-if="doc.heading"
                class="strong font-key-virtue uppercase"
                :field="doc.heading"
            />
        </div>

        <div
            class="uk-grid-match flex flex-wrap -mx-5 -my-6"
            v-if="doc.elements.length"
        >
            <div
                v-for="(column, index) in columns"
                :key="index"
                class="px-5 py-6"
                :class="colClass + ' ' + column.alignment"
            >
                <div
                    v-for="(element, index) in column.elements"
                    :class="element.type != 'abstand' ? 'text-element' : ''"
                    :key="index"
                >
                    <div
                        v-if="element.type == 'paragraph'"
                        :class="'panel text-' + doc.alignment + ' ' + inverse"
                        v-html="$bard(element.bard)"
                    ></div>

                    <div
                        v-if="element.type == 'abstand'"
                        class="h-1"
                    ></div>

                    <div v-if="element.type == 'buttons'">
                        <div>
                            <div
                                class="flex flex-wrap -m-2"
                                :class="'justify-' + doc.alignment"
                            >
                                <div
                                    class="p-2"
                                    v-for="(button, index) in element.buttons"
                                    :key="index"
                                >
                                    <anchor
                                        class="btn ms-0.5 text-medium ms-1"
                                        :class="'btn-' + button.style"
                                        :field="button.link"
                                        v-if="button.link"
                                    >
                                        {{ button.link.title }}
                                    </anchor>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="element.type == 'icons'">
                        <div
                            class="flex flex-wrap -m-2"
                            :class="'justify-' + doc.alignment"
                        >
                            <div
                                class="p-2"
                                v-for="(icon, index) in element.icons"
                                :key="index"
                            >
                                <anchor
                                    :field="icon.link"
                                    class="btn-icon btn-icon-default btn-icon"
                                >
                                    <i :class="icon.icon"></i>
                                </anchor>
                            </div>
                        </div>
                    </div>

                    <text-image
                        v-if="element.type == 'bild'"
                        :class="'text-' + doc.alignment"
                        :doc="element"
                    />

                    <div v-if="element.type == 'punktfuehrer'">
                        <div
                            class="flex flex-wrap -m-2"
                            v-for="(row, index) in element.rows"
                            :key="index"
                        >
                            <div
                                class="flex-1 p-2"
                                uk-leader
                            >
                                <div class="strong heading font-medium">{{ row.name }}</div>
                                <span class="text-sm">{{ row.description }}</span>
                            </div>
                            <div class="p-2"><br />{{ row.value }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </article>
</template>

<script>
import TextImage from "@/components/TextImage";

export default {
    props: ["doc"],

    components: {
        TextImage
    },

    data() {
        return {
            columns: null
        };
    },

    watch: {
        doc() {
            this.update();
        }
    },

    computed: {
        isDark() {
            return this.$parent.isDark;
        },
        inverse() {
            return this.isDark ? "inverse" : "";
        },
        columnCount() {
            return Math.min(3, this.columns.length);
        },
        colClass() {
            switch (this.columnCount) {
                case 1:
                    return "w-full";
                case 2:
                    return "w-full md:w-1/2";
                case 3:
                    return "w-full md:w-1/2 lg:w-1/3";
            }
        },
        containerClass() {
            return this.columnCount === 1 ? "max-w-6xl" : "max-w-6xl";
        }
    },

    methods: {
        update() {
            var column = {
                elements: [],
                alignment: ""
            };
            var columns = [column];

            for (var i = 0; i < this.doc.elements.length; i++) {
                var element = this.doc.elements[i];

                if (element.type === "spalte") {
                    var alignment =
                        element.alignment === "center"
                            ? "my-auto"
                            : element.alignment === "bottom"
                            ? "mt-auto"
                            : "";

                    if (i !== 0) {
                        columns.push(
                            (column = {
                                elements: [],
                                alignment: alignment
                            })
                        );
                    } else {
                        column.alignment = alignment;
                    }
                } else {
                    column.elements.push(element);
                }
            }

            this.columns = columns;
        }
    },

    created() {
        this.update();
        console.log(this);
    }
};
</script>



// WEBPACK FOOTER //
// src/components/SectionText.vue